/**
 * 主键一律按字符串处理（DR-4.1：63 位时间序 ID，后端 JSON 序列化为字符串）。
 * 禁止 parseInt：超过 Number.MAX_SAFE_INTEGER 会静默丢精度。
 */
export type Id = string;

/** 后端约定的“空主键”。 */
export const ZERO_ID: Id = '0';

export function isZeroId(id: Id | null | undefined): boolean {
  return !id || id.trim() === '' || id.trim() === ZERO_ID;
}

/** 展示用：空值回退占位符。 */
export function formatId(id: Id | null | undefined, fallback = '-'): string {
  const value = (id ?? '').trim();
  return value === '' || value === ZERO_ID ? fallback : value;
}

/** 比较两个主键（容忍前后空白，不做数值转换）。 */
export function eqId(a: Id | null | undefined, b: Id | null | undefined): boolean {
  return (a ?? '').trim() === (b ?? '').trim();
}

/** 列表取“上一页最后一条主键”，供游标分页 lastId 使用。 */
export function lastIdOf<T extends { id: Id }>(rows: readonly T[]): Id | undefined {
  return rows.length > 0 ? rows[rows.length - 1]?.id : undefined;
}

/**
 * 主键降序比较（新→旧），等价于数值序且**不做数值转换**：
 * 先比长度再比字典序——19 位定长 id 的字典序本就等于数值序，
 * 但早期 18 位数据或跨节点 id 混排时会错序（进而让 `slice(0, size)` 漏单）。
 */
export function compareIdDesc(a: Id, b: Id): number {
  const left = (a ?? '').trim();
  const right = (b ?? '').trim();
  if (left.length !== right.length) return right.length - left.length;
  return left > right ? -1 : left < right ? 1 : 0;
}
